export default __webpack_public_path__ + "static/media/roadmap-q5.052a8781.png";